'use strict';

var addToCart = require('_core_ext/pages/product/addToCart');
var perimeterx = require('_core_ext/trackers/perimeterx');
var _ = require('lodash');

var util = require('_core_ext/util'),
    progress = require('_core_ext/progress'),
    JSConstants = require('_core_ext/pages/cart/constants'),
    CSSConstants = require('_core_ext/cssconstants'),
    pageContext = require('_core_ext/page');

var minicart = require('_core_ext/pages/cart/minicart'),
    delivery = require('_core_ext/pages/cart/delivery'),
    quantityModule = require('_core_ext/pages/product/quantity'),
    bonusProductsView = require('_core_ext/bonus-products/bonus-products-view');

var messageDismiss = require('_core_ext/pages/cart/messageDismiss');

function updateProductQuantity(url, quantity, isTriggeredByMiniCart, csrfInfo, pid) {
    var sctollY,
        requestData = {},
        csrfToken = csrfInfo.token,
        csrfName = csrfInfo.name,
        $sctollContainer = $(JSConstants.CLASS_CART_SCROLLZONE);

    if ($sctollContainer.length > 0) {
        sctollY = $sctollContainer.scrollTop();
    }

    if (SiteDynamic.RESERVE_COLLECT_ENABLE) {
        // Erorrs would be restored after cart update
        var productErrors = getProductsErrors($(JSConstants.CLASS_QTY_BLOCK));
        localStorage.setItem(JSConstants.LS_KEY_PRODUCTS_ERRORS, JSON.stringify(productErrors));
    }

    requestData[csrfName] = csrfToken;

    $.ajax({
        type: 'POST',
        url: util.appendParamsToUrl(url, {
            'Quantity': quantity,
            'countryCode': $('select[id$="_country"]').val(),
            scope: pageContext.ns
        }),
        data: requestData
    }).done(function(response) {
        var $response = $(response);
        var $products = $response.find(JSConstants.CLASS_ITEM);

        $(document).trigger('product.changedQuantity', [pid.toString(), quantity]);

        if ($products.length === 0) {
            location.reload();
        } else {
            $(JSConstants.CLASS_CART_CONTENT).html(response);
            var $cartItemsForm = $(JSConstants.CLASS_CART_ITEMS_FORM),
                validator = $cartItemsForm.validate();

            validator.resetForm();
            quantityModule.availabilityQuantity(
                !SiteDynamic.RESERVE_COLLECT_ENABLE,
                SiteDynamic.RESERVE_COLLECT_ENABLE
            );

            if (sctollY) {
                $(JSConstants.CLASS_CART_SCROLLZONE).scrollTop(sctollY);
            }
        }

        if (!isTriggeredByMiniCart) {
            minicart.update();
        }
    }).fail(function(response) {
        perimeterx.handleResponce(response);
    });
}

function updateProductQuantityHandler(event, isTriggeredByMiniCart) {
    event.stopImmediatePropagation();
    var $this = $(this),
        $container = $this.closest(JSConstants.CLASS_QUANTITY);

    if (!$container.length) {
        return;
    }

    var $quantityInput = $container.find('input[type="number"]'),
        $csrfInput = $container.find('input[name="' + Constants.CSRF_TOKEN_NAME + '"]');

    var quantity = parseInt($quantityInput.val()),
        pid = $quantityInput.data('product-id'),
        url = $container.data('url');

    progress.show($container);
    updateProductQuantity(url, quantity, isTriggeredByMiniCart, {
        token: $csrfInput.val(),
        name: $csrfInput.attr('name')
    }, pid
    );
}

function responsiveAccordionTableSavedProducts(e) {
    e.preventDefault();

    if (window.screen.width < 768) {
        if (this.parentNode.classList.contains("active")) {
            this.parentNode.classList.remove("active");
        }
        else  {
            this.parentNode.classList.add("active");
        }
    }
}

function submitPromoForm(e) {
    e.preventDefault();

    var $btn = $(this),
        $form = $(JSConstants.CLASS_CART_PROMO_FORM),
        $codeInput = $form.find(JSConstants.ID_CART_COUPON_INPUT),
        $error = $form.find('div.error'),
        currentError = $error.length ? $error.text().trim() : '',
        hasErrorMessage = currentError.length > 0,
        data = $form.serialize();

    if ($codeInput.val() === '') {
        $error.text($codeInput.data('msgRequired'));
        return;
    }

    data += (data ? '&' : '') + $btn.attr('name') + '=true';
    $btn.attr('disabled', true);

    $.ajax({
        'url' : $form.attr('action'),
        'type': 'POST',
        'data': data,
    }).done(function (response) {
        var $response = $(response),
            $content = $response.find(JSConstants.CLASS_CART_CONTENT);

        if ($content.length) {
            $btn.attr('disabled', false);
            $(JSConstants.CLASS_CART_CONTENT).html($content.html());

            if (hasErrorMessage) {
                $form = $(JSConstants.CLASS_CART_PROMO_FORM);
                $error = $form.find('div.error');

                if ($error.length) {
                    $error.addClass('wrong-entry');
                }
            }
        } else {
            pageContext.redirect(Urls.shoppingCartStart);
        }
    });
}

function getProductsErrors($elements) {
    var errorsMap = {};

    $elements.each(function (i, qty) {
        var $container = $(qty).find(JSConstants.CLASS_QTY_CMP),
            $errorMsg = $(qty).find(JSConstants.CLASS_QTY_ERROR),
            $input = $container.find(JSConstants.CLASS_QTY_CURRENT),
            $decButton = $container.find(JSConstants.CLASS_DECR),
            $incButton = $container.find(JSConstants.CLASS_INC);

        var productId = $input.data('product-id');
        var errorVisible = $errorMsg.length && $errorMsg.is(':visible');

        if ($input.length && productId && errorVisible) {

            errorsMap[productId] = {
                prevError: $errorMsg.text(),
                incEnabled: !$incButton.hasClass(CSSConstants.DISABLED),
                decEnabled: !$decButton.hasClass(CSSConstants.DISABLED),
            };
        }
    });

    return errorsMap;
}

function checkAjaxLoading() {
    let scrollPlaceholder = document.querySelector('.js-scroll-placeholder');

    if (scrollPlaceholder) {
        const bottomCoord = scrollPlaceholder.getBoundingClientRect().bottom;
        const height = document.documentElement.clientHeight;
        if (height >= bottomCoord) {
            const url = scrollPlaceholder.getAttribute('data-url');
            scrollPlaceholder.remove();
            $.ajax({
                type: 'GET',
                url: url
            }).done(function(response) {
                response = typeof response === 'string' ? response.trim() : response;
                let container = document.querySelector('ul.js-save-for-later-list');
                scrollPlaceholder = document.querySelector('.js-scroll-placeholder');
                container.insertAdjacentHTML('beforeend', response);
            });
        }
    }
}

function hideSaveForLaterBtn () {
    const savedForLaterList = document.querySelector('.js-saved_products');
    if (savedForLaterList) {
        const saveForLaterBtn = savedForLaterList.querySelectorAll('button[value="Save for later"]');
        saveForLaterBtn.forEach(btn => btn.classList.add("hidden"));
    }
}

/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {

    $(function() {
        bonusProductsView.loadBonusOption();
    })
        .on('click', JSConstants.CLASS_EDIT_BONUS , function (e) {
            e.preventDefault();
            var url = this.href;
            url = util.appendParamsToUrl(url, {
                source: 'bonus',
                format: 'ajax',
                lazyLoad: 'false',
                pageStart: 0,
                pageSize: 10,
                bonusProductsTotal: -1
            });

            bonusProductsView.show(url, Resources.BONUS_PRODUCTS);
        })
        .on('click', JSConstants.CLASS_COUPON_ADD, function(e) {
            e.preventDefault();
            $(JSConstants.CLASS_COUPON_ADD_DISCLAIMER).addClass(CSSConstants.HIDDEN);
            $(JSConstants.CLASS_COUPON_ADD_FORM).removeClass(CSSConstants.HIDDEN);
            $(JSConstants.CLASS_COUPON_ADD_FORM).find('input').focus();
        })
        .on('input', JSConstants.CLASS_ITEM + ' ' + JSConstants.CLASS_QTY_CURRENT,
            _.debounce(updateProductQuantityHandler, 1000)
        )
        .on('keydown', JSConstants.CLASS_QTY_CURRENT, _.debounce(function(e) {
            var keyCode = e.keyCode || window.event.keyCode;

            if (keyCode === 13) {
                e.preventDefault();
                $(this).trigger('input');
            }
        }, 500))
        .on('click', JSConstants.CLASS_CART_TITLE, responsiveAccordionTableSavedProducts)
        .on('click', JSConstants.CLASS_PROMO_ANCHOR, function (e) {
            e.preventDefault();
            var topOffset = $(JSConstants.ID_ORDER_SUMMARY).offset().top;

            util.scrollBrowser(topOffset);
        })
        .on('submit', JSConstants.CLASS_CART_PROMO_FORM, function(e) {
            e.preventDefault();
        })
        .on('click', JSConstants.CLASS_CART_PROMO_FORM_ADD_COUPON, submitPromoForm)
        .on('click', JSConstants.CLASS_CART_PROMO_FORM_DELETE_COUPON, submitPromoForm);

    $(JSConstants.CLASS_COUPON_ADD_FORM).find('input').on('keydown', function (e) {
        var keyCode = e.keyCode || window.event.keyCode;
        if (keyCode === 13) {
            e.preventDefault();
            $(JSConstants.CLASS_COUPON_ADD_FORM).find('button').click();
        }
    });

    //to prevent multiple submissions of the form when removing a product from the cart
    var removeItemEvent = false;
    $('button[name$="deleteProduct"]').on('click', function (e) {
        if (removeItemEvent) {
            e.preventDefault();
        } else {
            removeItemEvent = true;
        }
    });

    $(document).on('clickCollect:SelectedStore', function(event, config) {
        if (config.isUpdate) {
            // TODO: invistigate how update cart with ajax without reloadig.
            location.reload();
        }
    });

    $(window).on('scroll', checkAjaxLoading);

    $(window).load(function() {
        util.restoreScroll();
    });
}

exports.init = function () {
    initializeEvents();
    addToCart();
    hideSaveForLaterBtn();

    delivery.init();
    messageDismiss.init();
};
